import { Chip as MuiChip } from '@mui/material'
import { RxCross2 } from 'react-icons/rx'
import { tss } from 'tss-react'
import {
  getChipBasePrimitives,
  getChipColorPrimitives,
} from '~/components/ui/atoms/chip/variants/primitives'
import { ChipProps } from '../types'

/**
 * Renders a chip with a solid background and a border
 */
export function OutlinedChip({
  color,
  className,
  isRounded = false,
  noPadding = false,
  ...rest
}: Omit<ChipProps, 'variant'>) {
  const { cx, classes } = useStyles({ color, isRounded, noPadding })

  return (
    <MuiChip
      className={cx(classes.chip, className)}
      deleteIcon={<RxCross2 className="min-h-4 min-w-4" size="16px" />}
      {...rest}
    />
  )
}

const useStyles = tss
  .withParams<Omit<ChipProps, 'variant'>>()
  .create(({ color, isRounded, noPadding }) => {
    const colorPrimitives = getChipColorPrimitives('outlined', color)
    const chipBasePrimitives = getChipBasePrimitives('outlined', color, isRounded, noPadding)

    return {
      chip: {
        ...colorPrimitives,
        ...chipBasePrimitives,
      },
    }
  })
